<div class="back-to-list">
  <div class="navigation-left">
    <a class="arrow arrow-left" (click)="goBack()">{{ backToLabel }}</a>
  </div>
</div>
<form [formGroup]="form" (ngSubmit)="save()">
  <mat-card>
    <mat-card-title>{{ 'parameters/track-link-labels/details/title' | translate }}</mat-card-title>
    <mat-card-content>
      <p>
        <mat-form-field class="w-100">
          <mat-label translate="parameters/track-link-labels/details/label"></mat-label>
          <input matInput formControlName="label" />
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="w-100">
          <mat-label translate="parameters/track-link-labels/details/description"></mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
      </p>

      <ng-container *ngIf="templates?.length">
        <p translate="parameters/track-link-labels/details/template-dependencies"></p>

        <ul>
          <li *ngFor="let template of templates">
            <a [href]="template.url" rel="noopener noreferrer" target="_blank">{{ template.template_name }}</a>
          </li>
        </ul>
      </ng-container>
    </mat-card-content>
    <mat-card-actions *ngIf="form.enabled">
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="form.get('label').invalid || form.get('description').invalid"
        translate="save"></button>
      <button type="button" mat-raised-button translate="cancel" (click)="goBack()"></button>
    </mat-card-actions>

    <app-card-footer [data]="footerContent"></app-card-footer>
  </mat-card>
</form>
